module.exports = __webpack_public_path__ + "p6_img1.jpg?deccce72f2596cd7929e2cc77d92272b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img1.jpg
// module id = 122
// module chunks = 0